import { useMemo } from 'react';

import { CMSApiBase, CMSImageBase } from '@/api/cms/base';
import { isPromoAvailableDate } from '@/helpers/dateTime';
import { useServer } from '@/modules/server/context/ServerEnvContext';

export interface IMobileAppCMS {
  showAndroid: boolean;
  androidApk?: CMSImageBase;
}

interface IBrandAssets {
  logoDesktop: CMSImageBase | null;
  logoMobile: CMSImageBase | null;
  preloader: CMSImageBase | null;
  vipAnimatedLogo: CMSImageBase | null;
  animatedLogo: boolean;
}

interface ICMSConfigDateRange {
  start: string;
  end: string;
}

export interface ICMSConfigState {
  bonanzaPromo: {
    dateRange?: ICMSConfigDateRange;
    availableByDate: boolean;
  };
  scratchGame: {
    dateRange?: ICMSConfigDateRange;
    availableByDate: boolean;
  };
  fortuneWheel: {
    dateRange?: ICMSConfigDateRange;
    availableByDate: boolean;
  };
}

export interface ICMSConfigApi extends CMSApiBase {
  bonanzaPromo?: ICMSConfigDateRange;
  scratchGame?: ICMSConfigDateRange;
  fortuneWheel?: ICMSConfigDateRange;
  mobileApp?: IMobileAppCMS;
  brandAssets?: IBrandAssets;
}

export const useCMSConfig = () => {
  const { cmsConfig: data } = useServer();

  const cmsConfig: ICMSConfigState | null = useMemo(() => {
    if (!data) return null;
    return {
      bonanzaPromo: {
        dateRange: data.bonanzaPromo,
        availableByDate: isPromoAvailableDate(
          data.bonanzaPromo?.start,
          data.bonanzaPromo?.end
        ),
      },
      scratchGame: {
        dateRange: data.scratchGame,
        availableByDate: isPromoAvailableDate(
          data.scratchGame?.start,
          data.scratchGame?.end
        ),
      },
      fortuneWheel: {
        dateRange: data.fortuneWheel,
        availableByDate: isPromoAvailableDate(
          data.fortuneWheel?.start,
          data.fortuneWheel?.end
        ),
      },
    };
  }, [data]);

  const mobileAppCMS = useMemo(() => {
    if (!data) return null;
    return data.mobileApp || null;
  }, [data]);

  const brandAssets = useMemo(() => {
    if (!data) return null;
    return data.brandAssets || null;
  }, [data]);

  return { cmsConfig, mobileAppCMS, brandAssets };
};
